import PatientForm, { getFormValues, emptyValuesFilter } from './PatientForm';

export {
  getFormValues,
  emptyValuesFilter,
};

export default PatientForm;
